// extracted by mini-css-extract-plugin
module.exports = {"OfficeCard_heading":"OfficeCard_OfficeCard_heading__AJxk0","OfficeCard_textbox":"OfficeCard_OfficeCard_textbox__bL3b4"};